/*
*###############################################################################
*Module Name                   : VoucherTransferOutContent.js                  #
*Purpose of the Module         :                                               #
*Description of the Module     :                                               #
*Original Author               :  W M Shanika Chamodi                          #
*Date                          : Tuesday, January 4th 2022, 1:00:26 pm         #
*Copyright © 2022 myPOS Software Solution (pvt Ltd.)                           #
*###############################################################################
*/
import React, { useState } from "react"
import {
  CardText,
  Col,
  Row,
  Alert,
  Button,
} from "reactstrap"
//Import Framework components
import DPTextBox from "framework/components/DPTextBox"
import DPSearchBoxDynamic from "framework/components/DPSearchBoxDynamic"
import DPTextBoxTow from "framework/components/DPTextBoxTow"
const VoucherTransferOutContent = ({
  Gen_DataSearch,
  AlertColor,
  AlertMsg,
  show,
  Gen_Code,
  Gen_Code_OnChange,
  Gen_Code_onBlur,
  Gen_Code_Enabled,
  Gen_FromLocation,
  Gen_FromLocation_OnChange,
  Gen_FromLocation_Enabled,
  Gen_ToLocation,
  Gen_ToLocation_OnChange,
  Gen_ToLocation_Enabled,
  Gen_TxnDate,
  Gen_TxnDate_OnChange,
  Gen_TxnDate_Enabled,
  Gen_Remark1,
  Gen_Remark1_OnChange,
  Gen_Remark1_Enabled,
  Gen_Remark2,
  Gen_Remark2_OnChange,
  Gen_Remark2_Enabled,

  SearchDefaultSortedMain,
  SearchModelOpenMain,
  SearchModelTriggerMain,
  SearchGetSelectRowMain,
  Gen_mainSearchEnabled,
  menuCode,
  LocationCode,
  model_xlarge_locTo,
  model_xlarge_locFrom,
  tox_xlarge_locTo,
  tox_xlarge_locFrom,
  locationOnblurTo,
  locationOnblurFrom,
  locationDescFrom,
  locationDescTo,
  GetSelectRowLocFrom,
  GetSelectRowlOCTo,
  locationFromDisable,
  locationToDisable,
  tox_xlarge_request,
  model_xlarge_request,
  GetSelectRowRequest,
  vouRequestDoc,
  vouRequestDocOnchange,
  vouRequestDocOnblur,
  disabled,
  vouRequestDocDisable
}) => {

  const [mainSearchCol, setmainSearchCol] = useState([])
  const [Datatablesub, SetDatatablesub] = useState([])
  const [mainSearchColLoc, setmainSearchColLoc] = useState([])
  const [groupFilter, SetGroupFilter] = useState('a')
  //*** End of useStates */
  const ApiURL = window.Links.ApiURL

  return (
    <React.Fragment>
      <div>
        <Col sm="12">
          <CardText className="mb-0">
            <Row>
              {show ? (
                <Alert color={AlertColor} role="alert">
                  {AlertMsg}
                </Alert>
              ) : null}
              <Col sm={12} md={6} className="mb-4-sm">
                <Row>
                  <Col>
                    <DPTextBox
                      rowClass="mb-4-sm"
                      labelText="Document No"
                      textType="text"
                      maxLength="13"
                      value={Gen_Code}
                      onChange={Gen_Code_OnChange}
                      disabled={Gen_Code_Enabled}
                      onBlur={Gen_Code_onBlur}
                    />
                  </Col>
                  <Col sm={12} md={1} className="mb-4-sm">
                    <Button
                      onClick={Gen_DataSearch}
                      color="success"
                      className="btn-sm"
                      disabled={Gen_mainSearchEnabled}
                    >
                      <i
                        className="mdi mdi-search-web"
                        style={{ fontSize: "12px" }}
                      ></i>
                    </Button>
                  </Col>
                </Row>
                <Row>
                  <Col>

                    <DPTextBoxTow
                      labelText="From Location"
                      disabled1={locationFromDisable ? true : Gen_FromLocation_Enabled}
                      disabled2={true}
                      value1={Gen_FromLocation}
                      value2={locationDescFrom}
                      onChange1={Gen_FromLocation_OnChange}
                      onBlur1={locationOnblurFrom}
                    />
                  </Col>
                  <Col sm={12} md={1} className="mb-4-sm">
                    <Button
                      onClick={tox_xlarge_locFrom}
                      color="success"
                      className="btn-sm"
                      disabled={locationFromDisable}
                    >
                      <i
                        className="mdi mdi-search-web"
                        style={{ fontSize: "12px" }}
                      ></i>
                    </Button>
                  </Col>
                </Row>

                <Row>
                  <Col>
                    <DPTextBox
                      rowClass="mb-2-sm"
                      labelText="Remarks 1"
                      textType="text"
                      maxLength="50"
                      value={Gen_Remark1}
                      onChange={Gen_Remark1_OnChange}
                      disabled={Gen_Remark1_Enabled}
                    />
                  </Col>
                  <Col sm={12} md={1} className="mb-4-sm"></Col>
                </Row>

              </Col>
              <Col sm={12} md={6} className="mb-4-sm">
                <Row>
                  <Col>
                    <DPTextBox
                      rowClass="mb-4-sm"
                      labelText="Date"
                      textType="date"
                      value={Gen_TxnDate}
                      onChange={Gen_TxnDate_OnChange}
                      disabled={Gen_TxnDate_Enabled}
                    />
                  </Col>
                  <Col sm={12} md={1} className="mb-4-sm"></Col>
                </Row>
                <Row>
                  <Col>
                    <DPTextBoxTow
                      labelText="To Location"
                      disabled1={locationToDisable ? true : Gen_ToLocation_Enabled}
                      disabled2={true}
                      value1={Gen_ToLocation}
                      value2={locationDescTo}
                      onChange1={Gen_ToLocation_OnChange}
                      onBlur1={locationOnblurTo}
                    />
                  </Col>
                  <Col sm={12} md={1} className="mb-4-sm">
                    <Button
                      onClick={tox_xlarge_locTo}
                      color="success"
                      className="btn-sm"
                      disabled={locationToDisable}
                    >
                      <i
                        className="mdi mdi-search-web"
                        style={{ fontSize: "12px" }}
                      ></i>
                    </Button>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <DPTextBox
                      rowClass="mb-2-sm"
                      labelText="Remarks 2"
                      textType="text"
                      maxLength="50"
                      value={Gen_Remark2}
                      onChange={Gen_Remark2_OnChange}
                      disabled={Gen_Remark2_Enabled}
                    />
                  </Col>
                  <Col sm={12} md={1} className="mb-4-sm"></Col>
                </Row>
                <Row>
                  <Col>
                    <DPTextBox
                      labelText="Voucher Request"
                      disabled={disabled ? true : vouRequestDocDisable}
                      value={vouRequestDoc}
                      onChange={vouRequestDocOnchange}
                      onBlur={vouRequestDocOnblur}

                    />
                  </Col>
                  <Col sm={12} md={1} className="mb-4-sm">
                    <Button
                      onClick={tox_xlarge_request}
                      color="success"
                      className="btn-sm"
                      disabled={disabled ? true : vouRequestDocDisable}
                    >
                      <i
                        className="mdi mdi-search-web"
                        style={{ fontSize: "12px" }}
                      ></i>
                    </Button>
                  </Col>
                </Row>
              </Col>
            </Row>

            <Row>
              <Col sm={12} md={6} className="mb-3-sm"></Col>
              <Col sm={12} md={6} className="mb-3-sm"></Col>
            </Row>
          </CardText>
        </Col>
        {/* 
        <DPSearchBox
          searchData={SearchDataTablesMain}
          columns={SearchColumnsMain}
          defaultSorted={SearchDefaultSortedMain}
          mainTitle="Voucher Transfer out Search"
          SelectType={"radio"} //checkbox for multipe, radio for single, ROW_SELECT_DISABLED for disable
          isOpen={SearchModelOpenMain}
          toggle={SearchModelTriggerMain}
          getSelect={SearchGetSelectRowMain}
        /> */}

        <DPSearchBoxDynamic
          searchData={Datatablesub}
          columns={mainSearchCol}
          defaultSorted={SearchDefaultSortedMain}
          mainTitle={"Voucher Transfer out Search"}
          SelectType={"radio"} //checkbox for multipe, radio for single, ROW_SELECT_DISABLED for disable
          isOpen={SearchModelOpenMain}
          toggle={SearchModelTriggerMain}
          getSelect={SearchGetSelectRowMain}
          APIURL={ApiURL}
          URLPath={"VOUTOUT"}
          MenuCode={menuCode}
          KeyVal={'TRN'}
          searchBy={'HED_RUNNO'}
          FilterStr={`AND HED_FROMLOC = ${LocationCode}`}
        />
        <DPSearchBoxDynamic
          searchData={Datatablesub}
          columns={mainSearchColLoc}
          defaultSorted={SearchDefaultSortedMain}
          mainTitle={"Supplier Search"}
          SelectType={"radio"} //checkbox for multipe, radio for single, ROW_SELECT_DISABLED for disable
          isOpen={model_xlarge_locFrom}
          toggle={tox_xlarge_locFrom}
          getSelect={GetSelectRowLocFrom}
          APIURL={ApiURL}
          URLPath={"LOCATION"}
          MenuCode={menuCode}
          KeyVal={'LOC'}
          searchBy={'LOC_CODE'}
          FilterStr={groupFilter}
        />

        <DPSearchBoxDynamic
          searchData={Datatablesub}
          columns={mainSearchColLoc}
          defaultSorted={SearchDefaultSortedMain}
          mainTitle={"Location Search"}
          SelectType={"radio"} //checkbox for multipe, radio for single, ROW_SELECT_DISABLED for disable
          isOpen={model_xlarge_locTo}
          toggle={tox_xlarge_locTo}
          getSelect={GetSelectRowlOCTo}
          APIURL={ApiURL}
          URLPath={"LOCATION"}
          MenuCode={menuCode}
          KeyVal={'LOC'}
          searchBy={'LOC_CODE'}
          FilterStr={groupFilter}
        />

        <DPSearchBoxDynamic
          searchData={Datatablesub}
          columns={mainSearchColLoc}
          defaultSorted={SearchDefaultSortedMain}
          mainTitle={"Voucher Request"}
          SelectType={"radio"} //checkbox for multipe, radio for single, ROW_SELECT_DISABLED for disable
          isOpen={model_xlarge_request}
          toggle={tox_xlarge_request}
          getSelect={GetSelectRowRequest}
          APIURL={ApiURL}
          URLPath={"VOUREQ"}
          MenuCode={menuCode}
          KeyVal={'REQ'}
          searchBy={'HED_RUNNO'}
          FilterStr={` AND HED_LOC = ${Gen_ToLocation}`}
        />



      </div>
    </React.Fragment>
  )
}
export default VoucherTransferOutContent
